import { ReactElement, useMemo } from 'react';
import { Typography } from '@mui/material';

import { RangeSelectorType } from 'modules/api/const';
import { useTranslation } from 'modules/i18n';

import { translation } from './translation';
import { useStyles } from './useStyles';

interface IRangeSelectorProps {
  value: RangeSelectorType;
  onChangeValue: (value: RangeSelectorType) => void;
}

export function RangeSelector({
  value,
  onChangeValue,
}: IRangeSelectorProps): ReactElement {
  const { t, keys } = useTranslation(translation);
  const position = useMemo(
    () =>
      ({
        [RangeSelectorType.Week]: 0,
        [RangeSelectorType.Month]: 1,
        [RangeSelectorType.SixMonths]: 2,
      })[value],
    [value],
  );
  const { cx, classes } = useStyles({ position });

  return (
    <div className={classes.root}>
      <Typography
        className={cx(
          classes.button,
          value === RangeSelectorType.Week && classes.active,
        )}
        component="button"
        type="button"
        variant="body1"
        onClick={() => onChangeValue(RangeSelectorType.Week)}
      >
        {t(keys.week)}
      </Typography>

      <Typography
        className={cx(
          classes.button,
          value === RangeSelectorType.Month && classes.active,
        )}
        component="button"
        type="button"
        variant="body1"
        onClick={() => onChangeValue(RangeSelectorType.Month)}
      >
        {t(keys.month)}
      </Typography>

      <Typography
        className={cx(
          classes.button,
          value === RangeSelectorType.SixMonths && classes.active,
        )}
        component="button"
        type="button"
        variant="body1"
        onClick={() => onChangeValue(RangeSelectorType.SixMonths)}
      >
        {t(keys.sixMonths)}
      </Typography>
    </div>
  );
}
